import { type AuthUser } from "wasp/auth";
import { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import CommonLayout from "../../components/layout/CommonLayout";
import "../admin-theme.css";
import { adminLayoutConfig } from "./adminConfig";

interface Props {
  user: AuthUser;
  children?: ReactNode;
}

const DefaultLayout: FC<Props> = ({ children, user }) => {
  const location = useLocation();

  if (!user.isAdmin) {
    return <Navigate to="/" replace />;
  }

  // Enable location dropdown for specific admin pages
  const shouldShowLocationDropdown =
    location.pathname === "/admin/permissions" ||
    location.pathname === "/admin/approvals" ||
    location.pathname === "/admin/recycle-bin";

  // Remove padding for admin pages that need full-width layout
  const shouldRemovePadding =
    location.pathname.startsWith("/admin/users") ||
    location.pathname === "/admin/locations" ||
    location.pathname.startsWith("/admin/location-types") ||
    location.pathname.startsWith("/admin/section-visibility") ||
    location.pathname === "/admin/permissions" ||
    location.pathname === "/admin/approvals" ||
    location.pathname === "/admin/recycle-bin" ||
    location.pathname === "/admin/domains" ||
    location.pathname === "/admin/geoblocking" ||
    location.pathname === "/admin/global-settings";

  const config = {
    ...adminLayoutConfig,
    showLocationDropdown: shouldShowLocationDropdown,
  };

  return (
    <div className="admin-surface">
      <CommonLayout config={config}>
        <div
          className={`w-full ${shouldRemovePadding
              ? ""
              : "px-6 py-4 md:px-8 md:py-6 2xl:px-10 2xl:py-8"
            }`}
        >
          {children}
        </div>
      </CommonLayout>
    </div>
  );
};

export default DefaultLayout;
